import _ from "lodash";

import Box from "components/Box";
import SanitizeHtml from "components/SanitizeHtml";

import NoContent from "entities/Deal/components/OverviewSections/NoContent";
import SectionContent from "entities/Memo/components/Sections/SectionContent";
import SectionHeader from "entities/Memo/components/Sections/SectionHeader";
import { IMemoSection } from "entities/Memo/sdk";
import { useDealSummaryByCategoryManager } from "entities/Memo/utils";

interface IPrintableSectionSummary {
  title?: string;
  section?: IMemoSection;
  category: string;
  dealId: number;
  externalToken?: string;
}

const PrintableSectionSummary = ({
  title = "",
  section,
  category,
  dealId,
  externalToken,
}: IPrintableSectionSummary) => {
  const { data: execSummary } = useDealSummaryByCategoryManager({
    token: externalToken,
    dealId,
    category: category,
  });

  return (
    <Box>
      <SectionHeader
        label={section?.title || title}
        alignActionButton="right"
      />
      <SectionContent>
        <Box
          sx={{
            "*": { lineHeight: "140% !important" },
            table: {
              width: "100%",
            },
            "table, th, td, tr": {
              borderCollapse: "collapse",
              border: "1px solid black !important",
            },
          }}
          data-testid="section-description"
        >
          {!_.isUndefined(execSummary) && !_.isEmpty(execSummary?.summary) ? (
            <SanitizeHtml
              html={execSummary.summary}
              dataTestid="description-value"
            />
          ) : (
            <NoContent />
          )}
        </Box>
      </SectionContent>
    </Box>
  );
};

export default PrintableSectionSummary;
